export interface NewsletterOptinData {
  email: string
  categories?: Record<string, boolean>
  firstName?: string
  lastName?: string
  gigyaId?: string
}

export interface NewsletterUpdateData extends Partial<Omit<NewsletterOptinData, 'email'>>, Pick<NewsletterOptinData, 'email'> {
  state: boolean
}

export async function newsletterCheck (email: string, baseUrl?: string) {
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')

  const response = await fetch((baseUrl ?? window.location.origin) + '/api/newsletter', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      checkEmail: email
    })
  })

  if (response.ok) {
    return await response.json()
  } else {
    throw await response.json()
  }
}

export async function newsletterOptin (data: NewsletterOptinData, baseUrl?: string) {
  return newsletterUpdate({...data, state: false }, baseUrl)
}

export async function newsletterUpdate (data: NewsletterUpdateData, baseUrl?: string) {
  const now = new Date().toISOString().split('.')[0]
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')

  return await fetch((baseUrl ?? window.location.origin) + '/api/newsletter', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      channel: {
        type: 'email',
        address: data.email,
        ...data.state ? {
          commercial_opted_in: now,
          open_tracking_opted_in: now,
          click_tracking_opted_in: now,
        } : {
          commercial_opted_out: now,
          open_tracking_opted_out: now,
          click_tracking_opted_out: now,
        },
        timezone: 'Europe/Budapest',
        locale_country: 'HU',
        locale_language: 'hu'
      },
      opt_in_mode: 'classic',
      ...data.categories && Object.keys(data.categories).length ? {
        tags: {
          interests: Object.entries(data.categories).filter(([key, val]) => val).map(([key]) => key)
        }
      } : null,
      attributes: {
        ...data.firstName ? {
          first_name: data.firstName,
        } : null,
        ...data.lastName ? {
          last_name: data.lastName,
        } : null,
        ...data.gigyaId ? {
          gigya_id: data.gigyaId,
        } : null,
      }
    })
  })
}

export async function newsletterOptout (token: string, baseUrl: string) {
  const url = `${baseUrl}/api/channels/email/custom-unsubscribe?ua_unsubscribe_token=${token}`
  return await fetch(url, {
    method: 'GET'
  })
}
